import { render } from "./crud-email.vue?vue&type=template&id=3b21f572&scoped=true&ts=true&lang=pug"
import script from "./crud-email.vue?vue&type=script&lang=ts"
export * from "./crud-email.vue?vue&type=script&lang=ts"

import "./crud-email.vue?vue&type=style&index=0&id=3b21f572&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b21f572"]])

export default __exports__